import { render, staticRenderFns } from "./ExternalRatingsWidget.vue?vue&type=template&id=6f3eac47"
import script from "./ExternalRatingsWidget.vue?vue&type=script&lang=js"
export * from "./ExternalRatingsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f3eac47')) {
      api.createRecord('6f3eac47', component.options)
    } else {
      api.reload('6f3eac47', component.options)
    }
    module.hot.accept("./ExternalRatingsWidget.vue?vue&type=template&id=6f3eac47", function () {
      api.rerender('6f3eac47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/dashboard/widgets/ExternalRatingsWidget.vue"
export default component.exports